// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__ExZvW","title":"Header_title___TxdX","left":"Header_left__1c9a2","clinicName":"Header_clinicName__3b8MR"};